var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgP3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9997 17.3334L22.6663 12M18.6663 20C18.6663 21.4728 17.4725 22.6667 15.9997 22.6667C14.5269 22.6667 13.333 21.4728 13.333 20C13.333 18.5272 14.5269 17.3334 15.9997 17.3334C17.4725 17.3334 18.6663 18.5272 18.6663 20Z",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8 11.5818 11.5817 8.00005 16 8.00005C17.4572 8.00005 18.8233 8.38962 20 9.0703",
    stroke: "#256BFD",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 16.0001C3.33301 10.0289 3.33301 7.04336 5.18799 5.18836C7.04299 3.33337 10.0286 3.33337 15.9997 3.33337C21.9708 3.33337 24.9564 3.33337 26.8113 5.18836C28.6664 7.04336 28.6664 10.0289 28.6664 16.0001C28.6664 21.9712 28.6664 24.9568 26.8113 26.8117C24.9564 28.6668 21.9708 28.6668 15.9997 28.6668C10.0286 28.6668 7.04299 28.6668 5.18799 26.8117C3.33301 24.9568 3.33301 21.9712 3.33301 16.0001Z",
    stroke: "#256BFD",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP3);
export default __webpack_public_path__ + "static/media/p3.4f483fd53055089305dedf495fc177b4.svg";
export { ForwardRef as ReactComponent };